import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { defaultOnError } from "util/conditional/onError";
const useFetchEntities = ({
  fetchKey,
  searchParams,
  fetchEntities,
  enabled,
  humanName,
  fetchOptions = {}
}) => {
  const { data, isInitialLoading, refetch } = useQuery({
    queryKey: fetchKey,
    queryFn: () => defaultOnError(
      fetchEntities(searchParams),
      `Fetching ${humanName} failed with status`,
      `Could not retrieve ${humanName}`
    ),
    enabled,
    placeholderData: keepPreviousData,
    ...fetchOptions
  });
  return {
    data,
    isInitialLoading,
    refetch
  };
};
export default useFetchEntities;
